export enum ElectricityFeeType {
  GREEN = 'green',
  BLUE = 'blue',
}
